export default __webpack_public_path__ + "static/media/ご参加にあたって.74699eb2.pdf";